export const sportIds = {
    "1": "futbol",
    "2": "basketbol",
    "5": "tenis",
    "23": "voleybol",
    "24": "karma"
};

export const sportTypes = {
    futbol: {
        id: 1,
        label: "Futbol",
        slug: "futbol"
    },
    basketbol: {
        id: 2,
        label: "Basketbol",
        slug: "basketbol"
    },
    tenis: {
        id: 5,
        label: "Tenis",
        slug: "tenis"
    },
    voleybol: {
        id: 23,
        label: "Voleybol",
        slug: "voleybol"
    },
    karma: {
        id: 24,
        label: "Karma",
        slug: "karma"
    }
};

export const matchScoreMuks = {
    tennis: "4_274_276",
    volleyball: "4_277"
};

export const matchStatus = {
    "halftime": { label: "D.A", slug: "da" },
    "pause": { label: "D.A", slug: "da" },
    "ended": { label: "Bitti", slug: "ended" },
    "1st_extra": { label: "Uz.", slug: "uz" },
    "2nd_extra": { label: "Uz.", slug: "uz" },
    "awaiting_extra_time": { label: "Uz.", slug: "uz" },
    "aet": { label: "Uz.", slug: "uz" },
    "penalties": { label: "Pen.", slug: "pen" },
    "awaiting_penalties": { label: "Pen.", slug: "pen" },
    "ap": { label: "Pen.", slug: "pen" },
    "suspended": { label: "Durdu", slug: "suspended" },
    "interrupted": {label: "Durdu", slug: "interrupted" },
};
